<template>
  <div class="box" ref="container">
    <div class="leftContent">
      <div class="tabs">
        <div class="tabTitle">
          <div class="tit">院校库</div>
          <div class="zk" v-if="isTabarShow" @click="isTabarShow = false">
            展开 <i class="el-icon-arrow-down"></i>
          </div>
          <div class="zk" v-else @click="isTabarShow = true">
            收起 <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div
          :class="
            isTabarShow
              ? 'isTabarShow tzy-filter-wrapper'
              : 'tzy-filter-wrapper'
          "
        >
          <div class="filter-list">
            <span class="filter-list-title"> 院校省份 </span>
            <div class="filter-list-tags">
              <span
                :class="it.check == true ? 'tag active' : 'tag'"
                v-for="(it, index) in regionList"
                :key="it.Id"
                @click="selectRegion(it, index)"
              >
                {{ it.Name }}
              </span>
            </div>
          </div>
          <div class="filter-list">
            <span class="filter-list-title"> 院校类型 </span>
            <div class="filter-list-tags">
              <span
                :class="it.check == true ? 'tag active' : 'tag'"
                v-for="(it, index) in typeList"
                :key="it.id"
                @click="selectType(it, index)"
              >
                {{ it.name }}
              </span>
            </div>
          </div>
          <div class="filter-list filter-list-college">
            <span class="filter-list-title"> 院校层次 </span>
            <div class="filter-list-tags">
              <span
                :class="it.check == true ? 'tag active' : 'tag'"
                v-for="(it, index) in gradationList"
                :key="it.id"
                @click="selectGradation(it, index)"
              >
                {{ it.name }}
              </span>
            </div>
          </div>
          <div class="filter-list">
            <span class="filter-list-title"> 院校搜索 </span>
            <div class="filter-list-tags">
              <!-- 搜索 -->
              <div class="customer-college">
                <el-input
                  size="small"
                  v-model="listObj.keyword"
                  placeholder="请输入学校名称"
                  @keyup.enter.native="servelist()"
                  suffix-icon="el-icon-search"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="schoolList"
        style="
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        "
      >
        <div class="tableTit">
          <div class="Tits" style="width: 250px; text-align: left">
            院校名称
          </div>
          <div class="Tit">所在地区</div>
          <div class="Tit">排名</div>
          <div class="Tit">招生专业</div>
          <div class="Tit">{{ startYear }}计划</div>
          <div class="Tit">较{{ startYear - 1 }}年</div>
        </div>
        <div class="tableItem">
          <div
            class="Item"
            v-for="it in list"
            :key="it._id"
            @click="goSchoolDetails(it._id)"
          >
            <div class="school" style="width: 250px; text-align: left">
              <div class="schoolImg">
                <img :src="it.logo" />
              </div>
              <div class="name">{{ it.name }}</div>
            </div>
            <div class="province">{{ it.provinceName }}</div>
            <div class="province">{{ it.rank }}</div>
            <div class="province">{{ it.planCount }}</div>
            <div class="province">{{ it.newPlan }}人</div>
            <div class="province" v-if="it.newPlan - it.oldPlan == 0">
              <span>相同</span>
            </div>
            <div class="province" v-if="it.newPlan - it.oldPlan < 0">
              <span class="ic"><img src="./images/x.png" alt="" /></span>
              <span>{{ it.newPlan - it.oldPlan }}</span>
            </div>
            <div class="province" v-if="it.newPlan - it.oldPlan > 0">
              <span class="ic"><img src="./images/s.png" alt="" /></span>
              <span>{{ it.newPlan - it.oldPlan }}</span>
            </div>
          </div>
        </div>
        <!-- 加载 -->
        <div
          v-if="showLoadMore"
          class="loading_wrap"
          ref="loadMoreRef"
        >
          <div class="loading" v-if="loading">
            <div class="container"></div>
          </div>
          <div>{{ loading ? "正在加载中" : "往下滚动加载更多数据" }}</div>
        </div>
      </div>
    </div>
    <div class="rightContent">
      <div class="banes">
        <div class="item" @click="goUrl('/Home/FirstPage')">
          <img src="./images/Frame 1000015157@2x.png" alt="" />
        </div>
        <div class="item" @click="goUrl('/Home/ZhanJiaList')">
          <img src="./images/Frame 1000015157@2x(1).png" alt="" />
        </div>
      </div>
      <div class="articleCont_right_zhengce">
        <div class="title">
          <div class="tit">院校推荐</div>
          <div class="more" @click="goUrl('/Home/ListRanking')">
            查看更多
            <i
              class="el-icon-arrow-right"
              style="color: #aeaeae; font-size: 14px"
            ></i>
          </div>
        </div>
        <div class="school-box">
          <div
            class="school-item"
            v-for="(it, index) in list"
            v-show="index <= 8"
            :key="index"
            @click="goSchoolDetails(it._id)"
          >
            <div class="schoolPhoto">
              <img :src="it.logo" alt="" />
            </div>
            <div class="schoolName">
              <span class="name"> {{ it.name }}</span>
              <span class="type">{{ it.provinceName }}.{{ it.utype[0] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRegionList } from "@/api/home";
import {
  GetUniversityPlanPro,
  getUniversityLevels,
  getUniversityTypes,
} from "@/api/ExpansionAndContraction";
export default {
  name: "SearchUniversityIndex",
  components: {},
  data() {
    return {
      isTabarShow: false,
      loading: false, // 列表请求中
      totalPage: 0,
      observer: null,
      listObj: {
        keyword: "",
        provinceName: [],
        utype: [],
        nature: [],
        pageIndex: 1,
        pageSize: 10,
      },
      list: [],
      // 已选择的院校省份
      regionArr: [],

      // 已选择的院校类型
      typeArr: [],

      // 已选择的院校层次
      gradationArr: [],

      // 已选条件数组
      tags: [],

      // 院校类型
      regionList: [],

      // 院校类型
      typeList: [],

      // 院校层次
      gradationList: [],

      startYear: ""
    };
  },
  created() {
    this.fetchUniversityTypes();
    this.fetchUniversityLevels();
  },
  mounted() {
    this.startYear = this.$store.state.user.startYear;
    setTimeout(() => {
      this.listObj.locationCode =
        this.$store.state.user.studentInfo.userExtend.provinceCode || "";
      this.listObj.Year =
        this.$store.state.user.studentInfo.userExtend.year || 2025;
      this.getRegionList();
      this.getList();
    }, 300);
  },
  beforeDestroy() {
    this.destroyObserver();
  },
  computed: {
    hasMoreData() {
      return this.totalPage > 0 && this.listObj.pageIndex < this.totalPage;
    },
    showLoadMore() {
      return this.loading || this.hasMoreData;
    },
  },
  methods: {
    servelist() {
      this.resetAndFetchList();
    },
    fetchUniversityTypes() {
      getUniversityTypes().then((res) => {
        this.typeList = res.data.result || [];
        this.typeList.forEach((item) => {
          this.$set(item, "check", false);
        });
        this.typeList.unshift({
          id: -2,
          code: "-2",
          name: "不限",
          check: true,
        });
      });
    },
    fetchUniversityLevels() {
      getUniversityLevels().then((res) => {
        this.gradationList = res.data.result || [];
        this.gradationList.forEach((item) => {
          this.$set(item, "check", false);
        });
        this.gradationList.unshift({
          id: "-1",
          name: "不限",
          check: true,
        });
      });
    },
    resetAndFetchList() {
      this.listObj.pageIndex = 1;
      this.totalPage = 0;
      this.list = [];
      this.destroyObserver();
      this.getList(1);
    },
    initObserver() {
      this.destroyObserver();
      if (!this.showLoadMore) {
        return;
      }
      this.$nextTick(() => {
        const loadMoreRef = this.$refs.loadMoreRef;
        if (!loadMoreRef) {
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry || !entry.isIntersecting) {
              return;
            }
            this.loadMoreData();
          },
          {
            root: null,
            rootMargin: "120px 0px",
            threshold: 0,
          }
        );
        this.observer.observe(loadMoreRef);
      });
    },
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
    loadMoreData() {
      if (this.loading || !this.hasMoreData) {
        return;
      }
      this.getList(this.listObj.pageIndex + 1);
    },
    // 跳转学校详情
    goSchoolDetails(Id) {
      this.$router.push({
        path: "/Home/SchoolDetails",
        query: { Id, showName: "查扩缩招" },
      });
    },
    // 获取冲稳保院校
    async getList(pageIndex = this.listObj.pageIndex) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.destroyObserver();
      try {
        const res = await GetUniversityPlanPro({
          ...this.listObj,
          pageIndex,
        });
        const result = res.data.result || {};
        const list = result.rows || [];

        this.totalPage = result.totalPage || 0;
        this.listObj.pageIndex = pageIndex;
        this.listObj.keyword = "";
        this.list = pageIndex === 1 ? list : [...this.list, ...list];
      } finally {
        this.loading = false;
        this.initObserver();
      }
    },
    // 选择院校省份
    selectRegion(it, idx) {
      this.disport(it, idx, this.regionList, this.regionArr);
    },

    // 选择院校类型
    selectType(it, idx) {
      this.disport(it, idx, this.typeList, this.typeArr);
    },

    // 选择院校层次
    selectGradation(it, idx) {
      this.disport(it, idx, this.gradationList, this.gradationArr);
    },

    // 获取省份数据
    async getRegionList() {
      const res = await GetRegionList({
        code: 0,
      });
      this.regionList = res.data.response;
      this.regionList.forEach((item) => {
        this.$set(item, "check", false);
      });
      this.regionList.unshift({
        Id: -1,
        Code: "-1",
        Name: "不限",
        check: true,
      });
    },
    getFilterItemLabel(item) {
      return item.Name || item.name || "";
    },

    // 合并
    mergeARR() {
      this.listObj.provinceName = [];
      this.listObj.utype = [];
      this.listObj.nature = [];
      this.regionArr.forEach((item) => {
        this.listObj.provinceName.push(this.getFilterItemLabel(item));
      });
      this.typeArr.forEach((item) => {
        this.listObj.utype.push(this.getFilterItemLabel(item));
      });
      this.gradationArr.forEach((item) => {
        this.listObj.nature.push(this.getFilterItemLabel(item));
      });
      this.resetAndFetchList();
    },

    // 重置
    rest() {
      this.tags = [];
      this.regionArr = [];
      this.gradationArr = [];
      this.typeArr = [];
      this.regionList.forEach((item) => {
        this.$set(item, "check", false);
      });
      this.typeList.forEach((item) => {
        this.$set(item, "check", false);
      });
      this.gradationList.forEach((item) => {
        this.$set(item, "check", false);
      });
      if (this.regionList[0]) {
        this.regionList[0].check = true;
      }
      if (this.typeList[0]) {
        this.typeList[0].check = true;
      }
      if (this.gradationList[0]) {
        this.gradationList[0].check = true;
      }
    },
    goUrl(url) {
      this.$router.push(url);
    },
    // 处理
    disport(it, idx, list, Arr) {
      const currentLabel = this.getFilterItemLabel(it);
      if (currentLabel !== "不限") {
        list[0].check = false;
        var index = Arr.findIndex(
          (item) => this.getFilterItemLabel(item) == currentLabel
        );
        // 没有就添加
        if (index == -1) {
          Arr.push(it);
          list[idx].check = true;
          this.mergeARR();
          // 有就删除
        } else {
          Arr.splice(index, 1);
          list[idx].check = false;
          this.mergeARR();
        }
        const hasChecked = list.some((item) => item.check == true);
        if (hasChecked) {
          list[0].check = false;
        } else {
          list[0].check = true;
        }
      } else {
        Arr.splice(0, Arr.length); //清空数组
        list.forEach((item) => {
          this.$set(item, "check", false);
        });
        list[0].check = true;
        this.mergeARR();
      }
    },
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  height: 0;
}

img {
  width: 100%;
  height: 100%;
}
.box {
  display: flex;
  width: 1280px;
  margin: 0 auto;
  min-height: 100vh;
  margin-top: 20px;
}

.leftContent {
  flex: 1;
  min-width: 956px;
  margin-right: 16px;
  .customer-college {
    font-size: 12px;
    color: #4a4a4a;
    letter-spacing: 0;
    line-height: 18px;
    z-index: 2;
    display: flex;
    align-items: center;
    background: #fff;
    ::v-deep .el-input__inner {
      height: 28px;
    }
    span {
      border-radius: 6px;
      width: 103px;
      height: 39px;
      color: rgb(255, 255, 255);
      background: #187cff;
      border: 1px solid #187cff;
      font-size: 14px;
      cursor: pointer;
      text-align: center;
      line-height: 39px;
      margin-left: 20px;
    }
  }

  .tabs {
    position: relative;
    width: 100%;
    padding: 16px 24px;
    box-sizing: border-box;
    border-radius: 8px 8px 8px 8px;
    background: #ffffff;
    .tabTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #eeeeee;
      .tit {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
      }
      .zk {
        font-size: 14px;
        cursor: pointer;
      }
    }
    .isTabarShow {
      display: none !important;
    }
    .tzy-filter-wrapper {
      box-sizing: border-box;
      display: block;
      .filter-list {
        display: flex;
        align-items: flex-start;
        margin-top: 10px;
        .filter-list-title {
          font-size: 14px;
          text-align: center;
          font-weight: bold;
        }

        .filter-list-tags {
          margin-left: 20px;
          flex: 1;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;

          .tag {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            font-style: normal;
            margin: 0 0 8px 10px;
            text-align: center;
            border-radius: 4px;
            cursor: pointer;
            box-sizing: border-box;
            min-width: 58px;
            text-align: left;
          }

          .tag:hover {
            color: #187cff;
          }

          .active {
            color: #187cff;
          }
        }
      }

      .college-level-wrapper {
        display: flex;

        .sx {
          font-weight: 100;
          height: 47px;
          display: flex;
          align-items: center;
          color: #e6e6e6;
          transform: translateY(-2px);
        }
      }
    }
  }

  .schoolList {
    margin: 20px 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    .tableTit {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      padding: 14px 24px 14px 24px;
      background: #f7f7f7;
      border-radius: 8px 8px 0px 0px;
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      font-size: 16px;
      .Tit {
        flex: 1;
        text-align: center;
      }
    }
    .tableItem {
      width: 100%;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      height: 100%;
    }
    .Item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 20px 24px 20px 24px;
      box-sizing: border-box;
      height: 88px;
      border-bottom: 1px solid #eeeeee;
      font-size: 16px;
      .school {
        display: flex;
        align-items: center;
        cursor: pointer;
        .schoolImg {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }
        .name:hover {
          color: #187cff;
        }
      }
      .province {
        flex: 1;
        text-align: center;
        .ic {
          display: inline-block;
          width: 13px;
          height: 10px;
          margin-right: 4px;
        }
      }
    }
  }
}
.rightContent {
  width: 308px;
  overflow: hidden;
  float: left;
  .banes {
    width: 100%;
    .item {
      cursor: pointer;
      width: 308px;
      height: 154px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .articleCont_right_zhengce > p {
    height: 21px;
    font-size: 20px;
    font-weight: 700;
    color: #333;
    margin-left: 24px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .articleCont_right_zhengce {
    width: 100%;
    background-color: #fff;
    border-radius: 14px;
    overflow: hidden;
    margin-bottom: 20px;
    padding-bottom: 6px;
    padding: 24px;
    box-sizing: border-box;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      .tit {
        font-weight: 600;
        font-size: 20px;
        color: #000000;
      }
      .more {
        font-size: 14px;
        color: #aeaeae;
        cursor: pointer;
      }
    }
    .school-box {
      margin-top: 38px;
      padding: 0 24px;
      div,
      .school-box .school-item {
        display: flex;
        align-items: center;
      }
      .school-item:hover .name {
        color: #187cff !important;
      }
      .school-item {
        margin-bottom: 24px;
        cursor: pointer;
        .schoolPhoto {
          width: 48px;
          height: 48px;
          margin-right: 12px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .schoolName {
          display: flex;
          flex-direction: column;
          align-items: baseline;
          .name {
            color: #333;
            font-size: 18px;
            margin-bottom: 10px;
            max-width: 180px;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap; /* 不换行 */
            overflow: hidden; /* 超出部分隐藏 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
          }
          .type {
            font-size: 14px;
            color: #888;
          }
        }
      }
    }
    .policy_title:hover {
      color: #187cff !important;
      cursor: pointer;
    }
  }
}

// ------loading样式---------
.loading_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  padding: 20px 0;

  .loading {
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border: 2px solid #ddd;
    border-radius: 50%;
    animation: rotate 1s linear infinite;
    margin-right: 10px;
  }

  .container {
    position: relative;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #fff;
  }
}

/*------loading动画---------*/
@keyframes rotate {
  from {
    transform-origin: center center;
    transform: rotate(0deg);
  }

  to {
    transform-origin: center center;
    transform: rotate(360deg);
  }
}
</style>
